const routes = {
  registerWizard: '/registrarme',
  root: '/',
  taxesKeyAuth: '/registrarme/clave-tributaria',
  uniquePassAuth: '/registrarme/auth/clave-unica',
  uniquePassAuthLogout: '/auth/clave-unica/logout'
}

export default routes
